/** Human-readable diesel/DEF quantity line for job cards and tables. */
export function formatFuelQuantities(job) {
  if (!job) return 'N/A';
  const parts = [];
  if (job.diesel_quantity > 0) parts.push(`${job.diesel_quantity} gal Diesel`);
  if (job.def_quantity > 0) parts.push(`${job.def_quantity} gal DEF`);
  if (!parts.length) return 'N/A';
  return parts.join(' / ');
}

export function formatDeliveredQuantities(job) {
  if (!job || (job.delivered_diesel <= 0 && job.delivered_def <= 0)) return null;
  const parts = [];
  if (job.delivered_diesel > 0) parts.push(`${job.delivered_diesel} gal Diesel`);
  if (job.delivered_def > 0) parts.push(`${job.delivered_def} gal DEF`);
  return parts.length ? parts.join(' / ') : null;
}
